import { graphql } from '@/gql';
import { queryExecute } from '@/Utils/graphqlAPI';
import type { DeliveryWhereInput, PaginationInputType } from '@/gql/graphql';

// Fragments
import './fragments/multiOrderPartialDetailedFragment';
import './fragments/singleOrderPartialFragment';
import './fragments/multiOrderPartialFragment';

export const getOrders = async ({
  where,
  pagination,
  isSingle,
  isDetail,
}: {
  where: DeliveryWhereInput;
  pagination?: PaginationInputType;
  isSingle?: boolean;
  isDetail?: boolean;
}) => {
  const query: any = isDetail
    ? graphql(`
        query getOrdersDetailed($where: DeliveryWhereInput!, $pagination: PaginationInputType!) {
          getOrders(where: $where, pagination: $pagination) {
            ...MultiOrderPartialDetailedFragment
          }
        }
      `)
    : isSingle
      ? graphql(`
          query getOrdersSingle($where: DeliveryWhereInput!, $pagination: PaginationInputType!) {
            getOrders(where: $where, pagination: $pagination) {
              ...SingleOrderPartialFragment
            }
          }
        `)
      : graphql(`
          query getOrdersMulti($where: DeliveryWhereInput!, $pagination: PaginationInputType!) {
            getOrders(where: $where, pagination: $pagination) {
              ...MultiOrderPartialFragment
            }
          }
        `);

  const response = await queryExecute({
    query,
    variables: {
      where,
      pagination,
    },
    fetchPolicy: 'no-cache',
  });

  return response.data.getOrders;
};
